import { useCallback, useMemo } from 'react';

import { usePlayerStore } from '../store/playerStore';
import type { PlayerFollowTarget } from '../types';

export function usePlayerFollowTarget() {
  const store = usePlayerStore();
  const followTarget = store.state.follow.target;
  const followVersion = store.state.follow.version;
  const activeActorId = store.state.activeActorId;
  const targetObject = store.getResolvedFollowTarget();

  const clearFollowTarget = useCallback(() => {
    store.setFollowTarget(null);
  }, [store]);

  return useMemo(
    () => ({
      followTarget,
      targetObject,
      setFollowTarget: (next: PlayerFollowTarget) => {
        store.setFollowTarget(next);
      },
      clearFollowTarget,
    }),
    [activeActorId, clearFollowTarget, followTarget, followVersion, store, targetObject],
  );
}
